<template>
  <Uploader
    v-model="fileList"
    class="upload"
    :preview-image="false"
    :before-read="beforeRead"
    :after-read="afterRead"
    :accept="accept"
  >
    <slot name="custom">
      <div class="custom">
        <template v-if="!img">
          <div class="icon-box">
            <img v-if="icon" :src="icon" class="icon" />
            <img src="@/assets/images/id-card-upload-add.png" class="add" />
            <img src="@/assets/images/id-card-upload-add-dark.png" class="add dark" />
          </div>
          <p class="text">{{ text }}</p>
        </template>
        <template v-else>
          <img v-if="img" :src="img" class="show-img" />
          <!--        预览-->
          <div class="btn-box">
            <div class="box">
              <a class="btn" @click="preview">
                <img src="@/assets/images/upload-preview.png" class="icon">
              </a>
              <a class="btn" @click="del">
                <img src="@/assets/images/upload-del.png" class="icon">
              </a>
            </div>
          </div>
          <!--        删除-->
        </template>
      </div>
    </slot>
  </Uploader>
</template>
<script>
import lrz from "lrz";
import { Uploader, Toast, ImagePreview } from "vant";

export default {
  name: "UploadImg",
  components: {
    Uploader
  },
  props: {
    icon: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: "上传图片"
    },
    img: {
      type: String,
      default: ""
    },
    putDir: {
      type: String,
      default: 'gygjqh_id_card'
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    quality: {
      type: Number,
      default: 0.7
    }
  },
  data() {
    return {
      fileList: []
    };
  },
  methods: {
    beforeRead(file) {
      this.toast = Toast({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: this.$t("common.uploading_text")
      });
      return true;
    },
    async afterRead(file) {
      try {
        file = await lrz(file.file, {
          quality: this.quality
        });
      } catch (e) {}
      const params = new FormData();
      params.append("file", file.file);
      params.append("put_dir", this.putDir);
      
      this.$apis
        .uploadFile(params)
        .then(res => {
          if(res.code && res.msg){
            this.$toast(res.msg)
            return
          }
          this.$emit("afterRead", { ...res, base64: file.base64 || file.content });
          this.toast.clear();
        })
        .catch(err => {
          this.toast.clear();
        });
    },
    preview() {
      ImagePreview([this.img]);
    },
    del() {
      this.fileList = [];
      this.$emit("del");
    }
  }
};
</script>

<style scoped lang="less">
.upload {
  width: 100%;
  border: 1px dashed rgba(23, 22, 28, 0.45);
  border-radius: 8px;
  ::v-deep .van-uploader__wrapper {
    justify-content: center;
  }
  .custom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    .icon-box {
      position: relative;
      width: 188px;
      height: 120px;
      margin-top: 48px;
      .icon {
        display: block;
        width: 100%;
        height: 100%;
      }
      .add {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 80px;
        height: 80px;
        &.dark{
          display: none;
        }
      }
    }
    .text {
      margin-top: 10px;
      padding-bottom: 28px;
    }
    .show-img {
      width: 100%;
      height: 100%;
      max-height: 400px;
    }
    .btn-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 9;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.2);
      .box {
        display: flex;
        .btn {
          width: 80px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          .icon{
            width: 56px;
            height: 56px;
          }
          & ~ .btn {
            margin-left: 20px;
          }
        }
      }
    }
  }
}
.black-theme{
  .upload{
    border-color: #FFFFFF;
    .custom{
      .text{
        color: #fff;
      }
      .icon-box{
        .add{
          display: none;
          &.dark{
            display: block;
          }
        }
      }
    }
  }
}

</style>
